import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { helpers: { getLoginFromMail, getUserId } } = core

const { decision, trainingType, trainingFrequency } = commonConfigValues

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const valueTable = {}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'register.ui',
      'register.fullName',
      'training.type',
      'training.name',
      'training.trainingDate',
      'training.cert',
      'training.flag'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.ui',
    title: 'Staff Member Personel No. (UI)',
    minSpace: 'Personel No. (UI) ',
    formField: true
  },
  {
    name: 'register.firstName',
    title: 'SM First Name',
    hidden: true,
    minSpace: 'SM ',
    formField: true
  },
  {
    name: 'register.lastName',
    title: 'SM Last Name',
    hidden: true,
    minSpace: 'SM ',
    formField: true
  },
  {
    name: 'register.fullName',
    title: 'Staff Member Name',
    formField: true,
    getCellValue: row =>
      `${row['register.firstName'] || ''} ${row['register.lastName'] || ''}`,
    maxChars: 100,
    minSpace: 'Staff Member '
  },
  {
    name: 'training.type',
    title: 'In-Service Training Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(trainingType, ['id', parseInt(row[`training.type`], 10)])
        ? _.find(trainingType, ['id', parseInt(row[`training.type`], 10)]).label
        : row[`training.type`],
    options: 'trainingType',
    filterField: true,
    minSpace: 'In-Service Training Type '
  },
  {
    name: 'training.name',
    title: 'In-Service Training Name',
    formField: true,
    type: 'select',
    options: 'trainingNames', //USERS MODIFIED LIST
    filterField: true,
    minSpace: 'In-Service Training Name '
  },
  {
    name: 'training.trainingDate',
    title: 'Training Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Training '
  },
  {
    name: 'training.frequency',
    title: 'Training Frequency Minimum',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(trainingFrequency, ['id', parseInt(row[`training.frequency`], 10)])
        ? _.find(trainingFrequency, [
            'id',
            parseInt(row[`training.frequency`], 10)
          ]).label
        : row[`training.frequency`],
    options: 'trainingFrequency',
    filterField: true,
    minSpace: 'Frequency Minimum '
  },
  {
    name: 'training.cert',
    title: 'Training Cert on File',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`training.cert`], 10)])
        ? _.find(decision, ['id', parseInt(row[`training.cert`], 10)]).label
        : row[`training.cert`],
    options: 'decision',
    filterField: true,
    minSpace: 'Training Cert '
  },
  {
    name: 'training.flag',
    title: 'Training Flag',
    formField: true,
    filterField: true,
    minSpace: 'Training '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'training',
      historyName: 'trainingHistory',
      label: 'Personnel',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Personnel Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'tra',
      activeName: 'training',
      historyName: 'trainingHistory',
      label: 'Training',
      icon: 'note',
      fields: [
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'training.type',
            label: 'In-Service Training Type',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.trainingType
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'training.name',
            label: 'In-Service Training Name',
            // multiple: true,
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.trainingnames
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          }
        ],
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'training.trainingDate',
          label: 'Training Date',
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v => (v ? undefined : 'Field is required')
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'training.frequency',
          label: 'Training Frequency Minimum',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.trainingFrequency
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'training.cert',
          label: 'Training Cert on File?',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.decision.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          name: 'training.flag',
          label: 'Training Flag'
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['training']

export const errors = [1, 2]

export const defaultNew = {
  training: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  trainingHistory: []
}

// "personneltrainings": [
//   {
//   "id": 1,
//   "registerId": 1,
//  "training": {
//    "historyId":1,
//   "trainingDate": "2001-01-01T23:28:56.782Z",
//   "type": 2,
//   "name": 5,
//   "frequency" : 2,
//   "cert" :2,
//   "flag": "dd"
// },
// "trainingHistory": []
//   }
// ]



// WEBPACK FOOTER //
// ./src/personnel/configs/trainings.js